var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{ref:"link",class:_vm.getClass(),attrs:{"target":_vm.getTarget(),"href":_vm.href},on:{"click":_vm.onLinkClick}},[_vm._v("\n  "+_vm._s(_vm.label))])}
var staticRenderFns = []

export { render, staticRenderFns }